<template>
  <popup v-model="showPopup" popup-header="Something went wrong" @close="closePopup">
    <slot v-if="ssoAccountExistsError" />
    <p v-else class="text-body mb-16">{{ errorPopupText ? errorPopupText : 'There was an error creating your account' }}</p>
    <Button variant="primary" value="Try again" size="medium" class="w-full mb-16" @click="retrySubmit" />
    <Button
      variant="outlined"
      value="Contact us"
      size="medium"
      class="w-full"
      href="https://support.sittercity.com/hc/en-us/requests/new?ticket_form_id=5652055814427"
      target="_blank"
    />
  </popup>
</template>

<script lang="ts">
import Popup from '@/components/popup/Popup.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'GenericSignUpError',
  components: { Popup, Button },
  props: {
    showError: Boolean,
    errorPopupText: String || null,
    ssoAccountExistsError: {
      default: false,
      type: Boolean,
    },
  },
  data(): any {
    return {
      showPopup: false,
    };
  },
  watch: {
    showError(val) {
      this.showPopup = val;
    },
  },
  methods: {
    closePopup(): any {
      this.$emit('close');
      this.showPopup = false;
    },
    retrySubmit(): any {
      this.showPopup = false;
    },
  },
};
</script>
